export const environment = {
  production: false,
  baseUrl: 'https://api.limitlesscare.com/',
  publicKey: `-----BEGIN PUBLIC KEY-----
MIIBCgKCAQEAwYZvWUx94Fw95tZsRcT7bucu6ZiD1SlBy5u0TwDMQ/eIQENZtmdrUHTTzM3TDWr+dj89oE4EfUy5qG+nzDrFxlD/9O92m8hBh3vXyJzO6QaJdCqa/Ecuzfrl+SoANnLQ9qkrh/U2hQlxBkQtc21dL/OCkCsxdo3TJJxtUY14MSPEo4Bc8XVgnN8444ddPpaDtNmqvOV8rZT+Wc1hae+4lAUCQq5AgDWJyfP+SSJN2fb00l7cDEzjmUVwRH8fWrsRXstlMrBl4hm5wiIKkKt/oXyucfC/xXUSJM77owlM1CPnw1Yf4Jdem4VaB/nqhQ/ezEbrl7JEnMRIvore2DPg6QIDAQAB
-----END PUBLIC KEY-----`,
  sentryDsn:'https://57a055e44600299e31a64dc4ed4fcecf@o4509055687524352.ingest.de.sentry.io/4509938889130064'
};
export const baseUrl = 'https://api.limitlesscare.com/';
